/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { Fragment, useEffect, useState } from 'react'
import TableBody from './TableBody'

export default function TableHead({
    tableData,
    setState, 
    state,
    invoice,
    setToastErrorMessage,
    oldState,
    errorIndex, 
    setErrorIndex,
    setAppliedError,
    mainReceivedAmount,
    isClickSelect,
    tableIndex}) {
    const [itemErrorIndex, setItemErrorIndex] = useState(null)
    useEffect(() => {
        setItemErrorIndex(null)
    }, [isClickSelect])
    
    return (
        <div className='mt-[5px]'>
            <table className=' w-full px-[21px]'>
                <thead className='bg-[#E6E8EA]'>
                    <tr className='collect-fee-th'>
                        <th className='py-1.5 px-[21px] min-w-[173px] font-normal'>
                            <span className='flex justify-start'>
                                Item Name
                            </span>
                        </th>
                        <th className='py-1.5 px-[21px] w-[170px] font-normal'>
                            <span className='flex justify-end'>
                                Item Amount
                            </span>
                        </th>
                        <th className='py-1.5 px-[30px]  w-[250px] font-normal'>
                            <span className='flex justify-end'>
                                Collected
                            </span>
                        </th>
                        <th className='py-1.5 px-[21px] w-[250px] font-normal'>
                            <span className='flex justify-end'>
                                Balance
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        tableData?.map((item, index) => (
                            <Fragment key={index+"itemdata"}>
                                <TableBody 
                                    item={item} 
                                    index={index} 
                                    tableIndex={tableIndex}
                                    setState={setState}
                                    state={state}
                                    setToastErrorMessage={setToastErrorMessage}
                                    oldState={oldState}
                                    errorIndex={errorIndex}
                                    setErrorIndex={setErrorIndex}
                                    itemErrorIndex={itemErrorIndex}
                                    setItemErrorIndex={setItemErrorIndex}
                                    setAppliedError={setAppliedError}
                                    mainReceivedAmount={mainReceivedAmount}
                                />
                            </Fragment>
                        ))}
                    <tr className='border-t '>
                        <td className='px-[21px] py-2 flex justify-start font-semibold'>
                            
                        </td>
                        <td className='py-2 px-[21px]'>
                            <span className='flex justify-end font-semibold'>
                                Total
                            </span>
                        </td>
                        <td className='py-2 flex justify-end mx-auto px-[21px] font-normal mr-1'>
                            <span className='flex justify-end font-semibold'>
                                {invoice?.received_amount?.toFixed(2) ? invoice?.received_amount?.toFixed(2) : "0.00"}
                            </span>
                        </td>
                        <td className='py-2 px-[21px]'>
                            <span className='flex justify-end font-normal'>
                                {invoice?.due_amount?.toFixed(2)}
                            </span>
                        </td>
                    </tr>
                </tbody>
                                
            </table>
        </div>
    )
}
